import { testFileType } from '../FileDropZone/utils.js';

var executablesList = ['action', 'apk', 'app', 'bat', 'bin', 'cmd', 'com', 'command', 'cpl', 'csh', 'exe', 'gadget', 'inf1', 'ins', 'inx', 'ipa', 'isu', 'job', 'jse', 'ksh', 'lnk', 'msc', 'msi', 'msp', 'mst', 'osx', 'out', 'paf', 'pif', 'prg', 'ps1', 'reg', 'rgs', 'run', 'scr', 'sct', 'shb', 'shs', 'u3p', 'vb', 'vbe', 'vbs', 'vbscript', 'workflow', 'ws', 'wsf', 'wsh', '0xe', '73', '89', 'a6p', 'ac', 'acc', 'acr', 'actm', 'ahk', 'air', 'app', 'arscript', 'as', 'asb', 'awk', 'azw2', 'beam', 'btm', 'cel', 'celx', 'chm', 'cof', 'crt', 'dek', 'dld', 'dmc', 'docm', 'dotm', 'dxl', 'ear', 'ebm', 'ebs', 'ebs2', 'ecf', 'eham', 'elf', 'es', 'ex4', 'exopc', 'ezs', 'fas', 'fky', 'fpi', 'frs', 'fxp', 'gs', 'ham', 'hms', 'hpf', 'hta', 'iim', 'ipf', 'isp', 'jar', 'js', 'jsx', 'ts', 'tsx', 'kix', 'lo', 'ls', 'mam', 'mcr', 'mel', 'mpx', 'mrc', 'ms', 'ms', 'mxe', 'nexe', 'obs', 'ore', 'otm', 'pex', 'plx', 'potm', 'ppam', 'ppsm', 'pptm', 'prc', 'pvd', 'pwc', 'pyc', 'pyo', 'qpx', 'rbx', 'rox', 'rpj', 's2a', 'sbs', 'sca', 'scar', 'scb', 'script', 'smm', 'spr', 'tcp', 'thm', 'tlb', 'tms', 'udf', 'upx', 'vlx', 'vpm', 'wcm', 'widget', 'wiz', 'wpk', 'wpm', 'xap', 'xbap', 'xlam', 'xlm', 'xlsm', 'xltm', 'xqt', 'xys', 'zl9'];
/** Конвертация файла в base64 */

var getBase64 = function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve({
        file: file,
        base64: reader.result
      });
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
};
/**
 * Валидация файла
 * @param file
 * @param options - параметры валидации {maxSize: number, accept: string}
 *
 */

var validateFile = function validateFile(file, options) {
  var valid = true;
  var error = {
    maxSize: false,
    format: false,
    isExecutable: false
  }; // TODO: может использовать sendNotification для отображения ошибок ?

  if (file && options) {
    if (options.maxSize && file.size / 1e6 > options.maxSize / 1024) {
      valid = false;
      error.maxSize = true;
    }

    var ext = file.name.split('.');
    var isExecutable = executablesList.some(function (x) {
      return ext.length > 0 && ext[ext.length - 1] === x;
    });

    if (isExecutable) {
      return {
        valid: false,
        error: Object.assign(Object.assign({}, error), {
          isExecutable: true
        })
      };
    }

    if (options.accept && options.accept !== '*') {
      if (!testFileType(file, options.accept)) {
        valid = false;
        error.format = true;
      }
    }
  }

  return {
    valid: valid,
    error: error
  };
}; // Асинхронная вилидация файлов

var validateFilesAsync = function promiseAllIterative(values, options) {
  return new Promise(function (resolve, reject) {
    var results = [];
    var completed = 0;
    values.forEach(function (file, index) {
      Promise.resolve(file).then(function (result) {
        if (validateFile(file, options).valid) {
          results[index] = getBase64(result);
          completed += 1;

          if (completed === values.length) {
            resolve(results);
          }
        }

        if (!validateFile(file, options).valid) {
          reject(validateFile(file, options).error);
        }
      });
    });
  });
};

export { getBase64, validateFile, validateFilesAsync };
